import { createFileRoute } from "@tanstack/react-router";
import { EsgPage, esgHead } from "@/pages/EsgPage";

export const Route = createFileRoute("/esg")({
  head: () => esgHead("da"),
  component: () => <EsgPage locale="da" />,
});
